import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BarChart, Bar, XAxis, YAxis, Cell } from 'recharts';

class PersoneticsBarChart extends Component {

    render () {
        const { data } = this.props;
        let barChartData;
        if(data.size > 0){
            const categories = data.get('categories');
            const series = data.get('series').map(i => {
                return i.get('value');
            });
            barChartData = categories.map((x, i) => {
                return {"name": x, "state": series.get(`${i}`) }
            });
        }
        return (
            <BarChart
                width={470}
                height={100}
                data={barChartData.toJS()}
                margin={{top: 5, right: 30, left: 20, bottom: 5}}
            >
                <XAxis dataKey="name" tickLine={false} axisLine={false}/>
                <YAxis tick={false} axisLine={false}/>
                <Bar dataKey="state" fill="#16aa8b" barSize={15}>
                    {
                        barChartData.map((data, index) => (
                            <Cell opacity={index == (barChartData.size-1) ? '0.8' : '0.5'} />
                        ))
                    }
                </Bar>
            </BarChart>
        );
    }
}

PersoneticsBarChart.propTypes = {
    animationBegin: PropTypes.number,
    axisLine: PropTypes.bool,
    bars: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
    fills: PropTypes.array,
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    interval: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    lastFills: PropTypes.array,
    legend: PropTypes.bool,
    margin: PropTypes.object,
    referenceLineData: PropTypes.object,
    referenceLineStroke: PropTypes.string,
    tooltip: PropTypes.bool,
    tooltipContent: PropTypes.func,
    unit: PropTypes.string,
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    xAxis: PropTypes.string.isRequired,
    xTickComponent: PropTypes.object
};

PersoneticsBarChart.defaultProps = {
    fills: [],
    legend: false,
    tooltip: true
}

export default PersoneticsBarChart;